import React, { useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import useInterval from "../useInterval"
import Loader from "../../../lib/ui/loader/Loader";
import { getappointment } from '../../../actions/appointment';
import BookingStatus from "../bookAppointment/components/BookingStatus";
import { toast } from 'react-toastify';
import { SignalerCtx } from "../../../lib/context";
import { LangCtx } from "../../../lib/context";


const ConfirmPayment=(props)=>{
    const { l } = useContext(LangCtx);
    // const location = useLocation();

    const { signaler } = useContext(SignalerCtx);

    const history = useHistory();

    const [active,setActive]=useState()
   

    // const [num,setNum]=useState()
    const [loading,setLoading]=useState(true)

   const [count,setCount]=useState(0)

//    const [id,setId]=useState("")


       useInterval(()=>{
        // let num = Math.floor(Math.random() * 101);
            getappointment(props.history.location.state.apptId && props.history.location.state.apptId).then((res)=>{


                if(res.status){
                    if(res.data.paymentStatus==="paid"){

                        setLoading(false);
                        setActive("BS")
                        toast.success(l.appointment_booked_successfully, {
                            position: toast.POSITION.TOP_RIGHT
                        })
                        if (signaler) {
                            signaler.renderAppoints(props.history.location.state.formData.doctorId, "PENDLIST");
                        }
                        //setNum("Success!");

                    }
                    else if (res.data.paymentStatus==="failed") {setLoading(false);
                                console.log("Failure Reason ",res.data && res.data.failure_reason)
                                setActive("FA")
                                toast.error(l.appointmentbooking_failed, {
                                    position: toast.POSITION.TOP_RIGHT
                                })
                                toast.error(res.data.failure_reason, {
                                    position: toast.POSITION.TOP_RIGHT
                                })
                                history.push("/payment-failure")
                            }
                    else if (count>3) {setLoading(false);
                        
                        //setNum("Initiated")
                setActive("INI")}
                }

                else if (count>3) {setLoading(false); 
                    console.log("Something Went Wrong !")
                    }
                

                

            })

            if (count>3) {setLoading(false); 
                console.log("Something Went Wrong !")
                }
            

            // if(num%2!==0){setLoading(false);setNum("Success!"); }
            // else if (num<10) {setLoading(false);setNum("Failed");}
            // else if (count>2) {setLoading(false); setNum("Initiated")}
            
            setCount(count+1)

            

                

        
        
        },loading ? 10000:null)

  


    return(
        <div>
                      
           {loading && <Loader/> }
          
           {(active ==="BS" || active ==="INI") &&  <BookingStatus active={active} formData={props.history.location.state.formData} doctorData={props.history.location.state.doctorData} />}
           {/* {active ==="INI" &&  <BookingStatus active={active} formData={props.history.location.state.formData} doctorData={props.history.location.state.doctorData} /> } */}
        </div>
    )
}


export default ConfirmPayment